// View ---------------------------------
function MakeViewActive(button) {
  const spans = button.querySelectorAll('.cells_dd2 span');
  const section = button.closest(
    '.shopify-section--main-collection, .shopify-section--featured-collections, .shopify-section--related-products'
  );
  const productList = section?.querySelector('.changing_view_points_dd');
  if (!productList) return;

  // ignore clicks while a change is running
  if (productList.classList.contains('view-loading')) return;

  let currentIndex = -1;
  spans.forEach((span, i) => {
    if (span.classList.contains('filled')) currentIndex = i;
  });
  const nextIndex = currentIndex === spans.length - 1 ? 0 : currentIndex + 1;

  const startTime = Date.now();
  const MIN_SHIMMER = 200;  // shimmer stays at least this long
  const MAX_WAIT = 300;    // never wait longer than this for images

  // 1. Image areas switch to shimmer, then the grid changes
  productList.classList.add('view-loading');

  requestAnimationFrame(() => {
    spans.forEach(span => span.classList.remove('filled'));
    spans[nextIndex].classList.add('filled');

    // 2. Wait for images, then reveal
    const imgs = [...productList.querySelectorAll('.product-card__image--primary')];
    const decoded = Promise.all(
      imgs.map(img => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()))
    );
    const timeout = new Promise(res => setTimeout(res, MAX_WAIT));

    Promise.race([decoded, timeout]).then(() => {
      const remaining = Math.max(0, MIN_SHIMMER - (Date.now() - startTime));
      setTimeout(() => {
        requestAnimationFrame(() => {
          productList.classList.remove('view-loading');
        });
      }, remaining);
    });
  });
}

//Model ---------------------------------
function MakeModelActive(element) {
  element.classList.toggle('active_dd1');
}
